import { useEffect, useState } from 'react'
import { CheckCircle2 } from 'lucide-react'

// Brief green "✓ Saved" indicator. Pass a `savedAt` timestamp (set to
// `Date.now()` right after a successful save). Disappears after 3 seconds.
//
// Usage:
//   const [savedAt, setSavedAt] = useState(0)
//   // after a successful save: setSavedAt(Date.now())
//   <SavedIndicator savedAt={savedAt} />
export default function SavedIndicator({ savedAt }) {
  const [, tick] = useState(0)
  useEffect(() => {
    if (!savedAt) return
    const t = setTimeout(() => tick(n => n + 1), 3100)
    return () => clearTimeout(t)
  }, [savedAt])
  if (!savedAt || Date.now() - savedAt >= 3000) return null
  return (
    <span className="inline-flex items-center gap-1 text-sm text-emerald-700">
      <CheckCircle2 className="w-4 h-4" /> Saved
    </span>
  )
}
